import React, { useEffect, useRef, useState } from "react";
import { Link, Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import * as manualGuideService from "../../../../services/manual-guide.service";
import Loader from "../../../../common/loader";
import { breakWord, formateDate, handleServerValidations, TrimText } from "../../../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { SWAL_SETTINGS } from "../../../../../../utils/Constants";
import { ReactSortable } from "react-sortablejs";
import RecordNotFound from "../../../../../restaurant/shared/recordNotFound";

// import $ from "jquery";

const ModuleImagesList = (props) => {
  const {t} = useTranslation();
  const loc = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const [loader, setLoader] = useState(false);
  const [showdefault, setShowDefault] = useState({});
  const [list, setList] = useState([]);
  const [refresh , setRefresh]=useState(false);
  const [moduleList , setModuleList] = useState([]);
  const [selectedModule , setSelectedModule] = useState("");
  const [sortableData, setSortableData] = useState([]);
  const sortingCloseBtn = useRef();
  const location = useLocation();

  useEffect(() => {
    let data = {panel_id : params.id , module_id : params.module_id};
    // if(selectedModule.length){
    //   data.module_id = selectedModule
    // }
    manualGuideService
      .moduleImageList(data)
      .then((response) => {
        console.log("View response-", response);
        setList(response && response.data ? response.data.list : []);
        setSortableData(response && response.data ? response.data.list : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
   
  }, [params.id , refresh ]);

  useEffect(()=>{
    let data = {panel_id : params.id};
    manualGuideService
    .moduleList(data)
    .then((response) => {
      console.log("View response-", response);
      setModuleList(response && response.data ? response.data.list : []);
    })
    .catch((error) => {
      console.log("error=====>", error);
    });
  } , [params.id , refresh]);

  const deleteModuleFunction = (id)=>{

    Swal.fire({
      customClass: 'swal-wide',
      title: t("msg_are_you_sure"),
      text: t("you_not_be_able_to_revert_this"),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#403fad',
      cancelButtonColor: '#f1388b',
      confirmButtonText: t("btn_yes_delete"),
      cancelButtonText: t("btn_cancel")
  }).then((result) => {
      if (result.isConfirmed) {
          manualGuideService.deleteImageModule(id).then(response => {
              if (response.success) {
                  Swal.fire({
                      icon: 'success',
                      text: response.message,
                      ...SWAL_SETTINGS
                  });
                  setRefresh(!refresh)

              } else {
                  Swal.fire({
                      icon: 'error',
                      text: handleServerValidations(response),
                      ...SWAL_SETTINGS
                  })
              }
          }).catch(error => {
              console.log("deleteError");
          });
      }
  })

  };


  function handleSortCategories(closeModal = true) {
    manualGuideService.sortModuleImageList({ sorted_array: sortableData }).then((response) => {
      setRefresh(!refresh);
        if (response.success) {
            Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
            });
            if (closeModal) {
                sortingCloseBtn?.current?.click();
            }
          
        } else {
            Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
            });
        }
    }).catch((error) => {
        console.error("Error updating profile", error);
    });
}

//   function isSortingChanged(){
//     let changed = false;
//     let i = 0;
//     for (i; i < list.length; i++) {
//         if (list[i]?.order !== sortableData[i]?.order) {
//             changed = true;
//             break;
//         } else {
//             changed = false;
//         }
//     };
//     return changed;
// }

function isSortingChanged() {
  if (!Array.isArray(list) || !Array.isArray(sortableData)) return false;
  if (list.length !== sortableData.length) return true;

  for (let i = 0; i < list.length; i++) {
    const a = list[i];
    const b = sortableData[i];

    if (a?.order !== undefined && b?.order !== undefined) {
      if (a.order !== b.order) return true;
    } else {
      if (a?.title !== b?.title) return true;
    }
  }

  return false;
}


  const handleCloseSorting = () => {
    if (isSortingChanged()) {
        Swal.fire({
            title: t("question_to_save_data"),
            text: t("confirm_heading_found_unsaved_data_description"),
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#6c757d",
            cancelButtonColor: "#dc3545",
            confirmButtonText: t("btn_text_save_changes"),
            cancelButtonText: t("btn_text_discard"),
            customClass: {
                popup: 'swal-restaurant',
                confirmButton: 'btn btn-secondary col',
                cancelButton: 'btn btn-danger col'
            },
            allowOutsideClick: false
        }).then((result) => {
            if (result.isConfirmed) {
                handleSortCategories(false);
            } else {
              setSortableData(list);
            }
        });
    }
};

const handleAddImage = (module_id , order_no , type) => {
  const currentPath = location.pathname; 
  let order = 0;
  if(type==="before"){
   
 
      order = Number(order_no)-1;
    
    
  }
  else{
    order = Number(order_no)+1  
  }

  let newPath = currentPath.replace('/modules-images', `/modules-images/add`);
  newPath = newPath+`/${order}`
  navigate(newPath);
};


  return (
    <>
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body p-0">
            <div className='d-flex justify-content-between align-items-center mb-4'>
                            <h6 className="main-content-label">Modules Images </h6>
                         
                            <div className='d-flex align-items-center'>
                            {/* <div className="form-group mb-0 filter_icon_container filter_design me-4">
                              <i className="fa fa-filter mr-2 filter_icon"></i>
                            <div className="select-down-arrow">
                            <select className="form-control cp" onChange={(e) => { setSelectedModule(e.target.value)}}>
                             <option value="">Select Module</option>
                             {
                              moduleList.map((item)=>{
                                return(
                                  <option value={item._id}>{item.title}</option>
                                )
                              })
                             }
                            </select>
                            </div>
                            </div> */}
                             <button className="btn ripple btn-main-primary signbtn mx-2" data-bs-toggle="modal" data-bs-target="#sort-modal-module-image">
                    {t("label_sort")}
                  </button>
                           
                                <button className="btn ripple btn-main-primary signbtn" onClick={() => navigate(`/admin/manual-guide/view/${params?.id}/modules-images/add/${params?.module_id}`)}>{t("btn_add_new")}</button>

                            </div>
                        </div>

              
              
              <div className="table-responsive">
              <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                <thead>
                  <tr>
                    <th className="position-relative select_head">
                      <span>{t("list_heading_sno")}</span>
                    </th>

                    <th>
                      Title
                    </th>
                    <th>
                      title (Japanese)
                    </th>

                    <th className="action_head">{t("list_heading_action")}</th>
                  </tr>
                </thead>
                <tbody>
                  {loader ? (
                    <tr>
                      <td colSpan={10}>
                        <Loader />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {list.length ? (
                        list.map((row, i) => {
                          return (
                            <tr
                              key={i}
                            >
                             <td>{i+1}</td>


                              <td>
                                {row?.title ? (
                                  <div className="d-flex">
                                    {row?.title ? TrimText(row.title, 30) : "N/A"}
                                  </div>
                                ) : (
                                  <div className="d-flex">N/A</div>
                                )}
                              </td>
                              <td>
                                {row?.title_ja ? (
                                  <div className="d-flex">
                                    {row?.title_ja ? TrimText(row.title_ja, 30) : "N/A"}
                                  </div>
                                ) : (
                                  <div className="d-flex">N/A</div>
                                )}
                              </td>

                              <td>
                                <div className="d-flex">
                               
                                  <button
                                    className="btn ripple btn-success mlAction"
                                    onClick={() => {
                                      navigate(`/admin/manual-guide/view/${params?.id}/modules-images/edit` , {state : {_id : row._id}})
                                    }}
                                  >
                                    {t("btn_edit")}
                                  </button>

                                  <button className="btn ripple btn-secondary mlAction" onClick={() => {deleteModuleFunction(row._id)}}>{t("btn_delete")}</button>


                                  <div className="btn-group mlAction">
                                    <button
                                      type="button"
                                      className="btn btn-dark dropdown-toggle"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                     Add Image 
                                    </button>
                                    <ul className="dropdown-menu">
                                      <li>
                                        <button
                                          className="dropdown-item"
                                          onClick={() => {
                                            handleAddImage(params.module_id , row?.order , "before");
                                          }}
                                        >
                                         Add Before This 
                                        </button>
                                      </li>

                                      <li>
                                        <button
                                          className="dropdown-item"
                                          onClick={() => {
                                            handleAddImage(params.module_id , row?.order , "after");
                                          }}
                                        >
                                         Add After This 
                                        </button>
                                      </li>

                                      <li>
                                        <button
                                          className="dropdown-item"
                                          onClick={() => navigate(`/admin/manual-guide/view/${params?.id}/modules-images/add/${params?.module_id}`)}
                                        >
                                         Add At the end 
                                        </button>
                                      </li>



                                    

                                    </ul>
                                  </div>

                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={10} className="text-center">
                            {t("msg_no_records")}
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
            </div>
          </div>
        </div>

        <div className="modal fade sort-modal-module-image" data-bs-backdrop="static" id="sort-modal-module-image" tabIndex="-1" aria-labelledby="sort-modalLabelModule" aria-hidden="true">
          <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalToggleLabel">
                  Sort Module Images
                </h1>
                <button type="button" className="btn-close btn-icon" onClick={handleCloseSorting} data-bs-dismiss="modal" aria-label="Close">
                  <i className="ti ti-x"></i>
                </button>
              </div>
              <div className="modal-body">
                {sortableData && sortableData.length ? (
                  <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Order Number</th>
                      <th>Title</th>
                      <th>Title (JA)</th>
                    </tr>
                  </thead>
                  <ReactSortable
                    tag="tbody"
                    list={sortableData}
                    setList={setSortableData}
                    ghostClass="dropArea"
                    handle=".dragHandle"
                    filter=".ignoreDrag"
                    preventOnFilter={true}
                  >
                    {sortableData.map((record, index) => (
                      <tr key={record.id || index}>
                        <td className="dragHandle">{record?.order ? record?.order : index+1}</td>
                        <td className="dragHandle">{TrimText(record.title , 30)}</td>
                        <td>{TrimText(record.title_ja , 30)}</td>
                      </tr>
                    ))}
                  </ReactSortable>
                </table>
                ) : (
                  <RecordNotFound heading="no_category_found_text" text="no_category_found_text_para" />
                )}
              </div>
              <div className="modal-footer justify-content-center">
                <button type="button" className="btn btn-danger me-2 d-none" data-bs-dismiss="modal" ref={sortingCloseBtn} aria-label="Close">
                  Close
                </button>
                <button type="button" className="btn ripple btn-main-primary signbtn" disabled={!isSortingChanged()} onClick={handleSortCategories}>
                  {t("btn_save_changes")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModuleImagesList;
